class AsignacionService {
  constructor() {}
  resources = () => ({
    planillas: {
      uri: `/v1/planillas`,
      method: ['get']
    },
    trabajadores: {
      uri: `/v1/trabajadores/porasignar`,
      method: ['get']
    }
  });
}

export default AsignacionService;
